// extracted by mini-css-extract-plugin
export var background = "tagslist-module--background--fUgyY";
export var linkwrapper = "tagslist-module--linkwrapper--Wfm2i";
export var tag = "tagslist-module--tag--E9V0q";
export var tagslistwrapper = "tagslist-module--tagslistwrapper--aE+LM";
export var whitebackground = "tagslist-module--whitebackground--RCqCw";